import { Box, Text } from '@factorialco/deprecated-design-system'
import { CheckCircle } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface WhatsIncludedProps {
  benefits: string[]
}

export const WhatsIncluded = ({ benefits }: WhatsIncludedProps) => {
  if (benefits.length === 0) return null
  return (
    <Box padding="s12" gap="s16">
      <Text.Header3 weight="semibold">
        {i18n.t('growth.product_modal_extended.whats_included')}
      </Text.Header3>
      <Box gap="s8" style={{ margin: '0', padding: '0' }}>
        {benefits.map((benefit, index) => (
          <Box key={`benefit-${index}`} flexDirection="row" gap="s4" alignItems="flexStart">
            <CheckCircle width="20" height="20" style={{ flexShrink: 0 }} color="#10B881" />
            <Text.Normal size="200" color="black">
              {benefit}
            </Text.Normal>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
